import React from 'react';

export default function XmitCell({ quickResponse }) {
  const qr = quickResponse || {};

  if (!qr.xmitNumber) {
    return <span style={{ fontSize: 12, color: '#94A3B8' }}>Not linked</span>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span style={{ fontFamily: "'DM Mono',monospace", fontSize: 12, color: '#0F172A' }}>
        {qr.xmitNumber}
      </span>
      {qr.xmitVerifiedAt ? (
        <span
          style={{
            fontSize: 10,
            fontWeight: 600,
            color: '#15803D',
            background: '#DCFCE7',
            padding: '2px 8px',
            borderRadius: 99,
            width: 'fit-content',
          }}
        >
          Verified
        </span>
      ) : (
        <span style={{ fontSize: 10, color: '#64748B' }}>Unverified</span>
      )}
    </div>
  );
}
